(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  const main = document.querySelector('main[data-template]');
  if (!main || !main.dataset.template.startsWith('index')) return;

  const heroWrapper = document.querySelector('.hero-wrapper');
  if (!heroWrapper) return;

  const heroLogo = heroWrapper.querySelector('.logo-block');
  const headerLogo = document.querySelector('.header-logo');
  if (!heroLogo || !headerLogo) return;

  // ── Helpers ────────────────────────────────────────────────────────────
  function clamp(v, lo, hi) {
    return Math.max(lo, Math.min(hi, v));
  }
  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  // ── State ──────────────────────────────────────────────────────────────
  // Total wheel delta (px) needed to complete the animation.
  // ~400px feels natural on both trackpad and mouse wheel.
  const THRESHOLD = 400;

  let clone = null;
  let startRect = null;
  let endRect = null;
  let sCX = 0,
    sCY = 0;

  let accumulated = 0; // total scroll delta consumed by the animation
  let currentT = 0; // current visual progress 0→1
  let raf = null;
  let done = false;

  // Touch tracking
  let touchStartY = null;

  // ── Setup ──────────────────────────────────────────────────────────────
  function setup() {
    startRect = heroLogo.getBoundingClientRect();
    endRect = headerLogo.getBoundingClientRect();
    if (startRect.width === 0 || endRect.width === 0) return false;

    sCX = startRect.left + startRect.width / 2;
    sCY = startRect.top + startRect.height / 2;

    clone = heroLogo.cloneNode(true);
    clone.removeAttribute('id');
    clone.style.cssText = `
      position: fixed;
      top: ${startRect.top}px;
      left: ${startRect.left}px;
      width: ${startRect.width}px;
      height: ${startRect.height}px;
      max-width: none;
      max-height: none;
      margin: 0; padding: 0;
      z-index: 9999;
      pointer-events: none;
      transform-origin: center center;
      will-change: transform;
      opacity: 1;
      transition: none;
    `;
    document.body.appendChild(clone);

    heroLogo.style.opacity = '0';
    document.body.setAttribute('data-hero-animating', '');

    return true;
  }

  // ── Render ─────────────────────────────────────────────────────────────
  function scheduleRender() {
    if (raf) return;
    raf = requestAnimationFrame(render);
  }

  function render() {
    raf = null;

    const eCX = endRect.left + endRect.width / 2;
    const eCY = endRect.top + endRect.height / 2;
    const scale = lerp(1, endRect.width / startRect.width, currentT);
    const tx = lerp(sCX, eCX, currentT) - sCX;
    const ty = lerp(sCY, eCY, currentT) - sCY;

    clone.style.transform = `translate3d(${tx.toFixed(3)}px,${ty.toFixed(3)}px,0) scale(${scale.toFixed(5)})`;

    if (currentT >= 1) finish();
  }

  // ── Finish ─────────────────────────────────────────────────────────────
  function finish() {
    done = true;
    removeListeners();

    // Snap to pixel-perfect final position with a fresh measurement
    const f = headerLogo.getBoundingClientRect();
    const fCX = f.left + f.width / 2;
    const fCY = f.top + f.height / 2;
    const scale = f.width / startRect.width;
    clone.style.transform = `translate3d(${(fCX - sCX).toFixed(3)}px,${(fCY - sCY).toFixed(3)}px,0) scale(${scale.toFixed(5)})`;

    // Reveal real logo + force navbar white (page is still at scrollY=0 so
    // data-sticky-state='active' hasn't fired yet — set opacity directly)
    headerLogo.removeAttribute('data-hero-logo-hidden');
    document.body.removeAttribute('data-hero-animating');
    const underlay = /** @type {HTMLElement|null} */ (document.querySelector('.header__underlay-closed'));
    if (underlay) underlay.style.opacity = '1';

    // Fade clone out once the real logo is painted
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transition = 'opacity 0.06s';
        clone.style.opacity = '0';
        setTimeout(function () {
          clone.remove();
          clone = null;
          heroLogo.style.display = 'none';
        }, 80);
      });
    });
  }

  // ── Wheel (mouse + trackpad) ───────────────────────────────────────────
  let setupDone = false;

  function onWheel(e) {
    if (done) return;

    e.preventDefault();

    if (!setupDone) {
      if (!setup()) return;
      setupDone = true;
    }

    accumulated = clamp(accumulated + e.deltaY, 0, THRESHOLD);
    currentT = accumulated / THRESHOLD;
    scheduleRender();
  }

  // ── Touch (mobile) ────────────────────────────────────────────────────
  function onTouchStart(e) {
    if (done) return;
    touchStartY = e.touches[0].clientY;
  }

  function onTouchMove(e) {
    if (done || touchStartY === null) return;

    const dy = touchStartY - e.touches[0].clientY; // positive = swipe up = scroll down

    e.preventDefault();

    if (!setupDone) {
      if (!setup()) return;
      setupDone = true;
    }

    // Touch deltas are smaller; scale up slightly
    accumulated = clamp(accumulated + dy * 1.5, 0, THRESHOLD);
    currentT = accumulated / THRESHOLD;
    touchStartY = e.touches[0].clientY; // update so each move is incremental
    scheduleRender();
  }

  function onTouchEnd() {
    touchStartY = null;
  }

  // ── Listener management ───────────────────────────────────────────────
  function addListeners() {
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
  }

  function removeListeners() {
    window.removeEventListener('wheel', onWheel);
    window.removeEventListener('touchstart', onTouchStart);
    window.removeEventListener('touchmove', onTouchMove);
    window.removeEventListener('touchend', onTouchEnd);
  }

  // ── Boot ──────────────────────────────────────────────────────────────
  function boot() {
    // Release the scroll lock set by the inline script in hero.liquid.
    document.documentElement.style.overflow = '';
    addListeners();
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot, { once: true });
  }
})();
